import React from 'react'
import { Card, Space, Row, Col, Typography, Image, Grid } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import CorrectKk from '../../assets/img/document/kk-correct.png';
import IncorrectKk from '../../assets/img/document/kk-incorrect.png';
import { withTranslation } from 'react-i18next';

const { Text } = Typography;
const { useBreakpoint } = Grid;

function GetBreakPoint() {
    const screens = useBreakpoint()
    return screens;
}

export function InfoKk(props) {
    const { xs } = GetBreakPoint()
    const { t } = props
    return (
        <Card className='border-radius-6' bodyStyle={{ padding: xs ? 8 : 32 }}>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={16}>
                                <CheckCircleFilled className='primary-color fs-28' />
                                <Image src={CorrectKk} width="100%" height={xs ? 100 : 165} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={12}>
                                <CloseCircleFilled className='danger-color fs-28' />
                                <Image src={IncorrectKk} width="100%" height={xs ? 105 : 175} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col xs={24} md={12}>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">{t('profile.document.info.ktp.title')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.first.normal1')}<Text className='dark-color' strong>{t('profile.document.info.ktp.first.bold')}</Text>{t('profile.document.info.ktp.first.normal2')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.second')}</Text>
                                <Text type="secondary">• {t('profile.document.info.ktp.third')}</Text>
                            </Space>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    )
}

export default withTranslation()(InfoKk)
